<template>
	<div class="content-wrapper">
		<student-profile-card :studentId="id" />

		<div
			class="mb-primary"
			v-if="
				logPropsData ||
				basicInfoPropsData ||
				languagePropsData ||
				personalPropsData ||
				marketingPropsData ||
				placementPropsData ||
				schedulePropsData ||
				financePropsData ||
				classPropsData ||
				packagesPropsData ||
				invoicePropsData||
				vanumberPropsData
			"
		>
			<div class="card p-primary border-0">
				<student-profile-form-wizard :tabs="computedTabs" />
			</div>
		</div>
	</div>
</template>

<script>
const StudentProfileLog = () => import("./Tabs/Log/Log.vue");
const StudentProfileBasicInfo = () => import("./Tabs/BasicInfo/BasicInfo.vue");
const StudentProfileLanguage = () => import("./Tabs/Language/Language.vue");
const StudentProfilePersonal = () => import("./Tabs/Personal/Personal.vue");
const StudentProfileMarketing = () => import("./Tabs/Marketing/Marketing.vue");
const StudentProfilePlacement = () => import("./Tabs/Placement/Placement.vue");
const StudentProfileSchedule = () => import("./Tabs/Schedule/Schedule.vue");
const StudentProfileFinance = () => import("./Tabs/Finance/Finance.vue");
const StudentProfileClass = () => import("./Tabs/Class/Class.vue");
const StudentProfilePackages = () => import("./Tabs/Packages/Packages.vue");
const StudentProfileInvoice = () => import("./Tabs/Invoice/InvoiceHistory.vue");
const StudentProfileVaNumber = () => import("./Tabs/VaNumber/VaNumber.vue");

export default {
	name: "StudentProfile",
	data() {
		return {
			id: null,
			logPropsData: null,
			basicInfoPropsData: null,
			languagePropsData: null,
			personalPropsData: null,
			marketingPropsData: null,
			placementPropsData: null,
			schedulePropsData: null,
			financePropsData: null,
			classPropsData: null,
			packagesPropsData: null,
			invoicePropsData: null,
			vanumberPropsData: null,
			studentProfileTabs: [
				// AKTIF
				{
					icon: "",
					name: "log",
					component: StudentProfileLog,
					permission: this.$can('view_list_student_studentprofile_tab_log'),
					class: "",
				},
				{
					icon: "",
					name: "basic info",
					component: StudentProfileBasicInfo,
					permission: this.$can('view_list_student_studentprofile_tab_basicinfo'),
					class: "",
				},
				// END AKTIF
				// {
				// 	icon: "",
				// 	name: "info",
				// 	component: "student-profile-tab-info",
				// 	permission: "",
				// 	class: "",
				// },
				// {
				// 	icon: "",
				// 	name: "school",
				// 	component: "student-profile-tab-school",
				// 	permission: "",
				// 	class: "",
				// },
				// AKTIF
				{
					icon: "",
					name: "language",
					component: StudentProfileLanguage,
					permission: this.$can('view_list_student_studentprofile_tab_language'),
					class: "",
				},
				{
					icon: "",
					name: "personal",
					component: StudentProfilePersonal,
					permission: this.$can('view_list_student_studentprofile_tab_personal'),
					class: "",
				},
				{
					icon: "",
					name: "marketing",
					component: StudentProfileMarketing,
					permission: this.$can('view_list_student_studentprofile_tab_marketing'),
					class: "",
				},
				{
					icon: "",
					name: "placement",
					component: StudentProfilePlacement,
					permission: this.$can('view_list_student_studentprofile_tab_placement'),
					class: "",
				},
				{
					icon: "",
					name: "schedule",
					component: StudentProfileSchedule,
					permission: this.$can('view_list_student_studentprofile_tab_schedule'),
					class: "",
				},
				{
					icon: "",
					name: "finance",
					component: StudentProfileFinance,
					permission: this.$can('view_list_student_studentprofile_tab_finance'),
					class: "",
				},
				{
					icon: "",
					name: "class",
					component: StudentProfileClass,
					permission: this.$can('view_list_student_studentprofile_tab_class'),
					class: "",
				},
				{
					icon: "",
					name: "packages",
					component: StudentProfilePackages,
					permission: this.$can('view_list_student_studentprofile_tab_packages'),
					class: "",
				},
				{
					icon: "",
					name: "invoice",
					component: StudentProfileInvoice,
					permission: this.$can('view_list_student_studentprofile_tab_invoice'),
					class: "",
				},
				{
					icon: "",
					name: "VA Number",
					component: StudentProfileVaNumber,
					permission: this.$can('view_list_student_studentprofile_tab_va_number'),
					class: "",
				},
				// END AKTIF
			],
		};
	},
	created() {
		let url = window.location.href;
		this.id = url.split("/").slice(-1)[0].split("?")[0];
		this.fetchData();
	},
	computed: {
		computedTabs() {
			return this.studentProfileTabs.map((tab) => {
				if (tab.name === "log") {
					return {
						...tab,
						props: {
							...tab.props,
							value: this.logPropsData,
						},
					};
				}
				if (tab.name === "basic info") {
					return {
						...tab,
						props: {
							...tab.props,
							value: this.basicInfoPropsData,
						},
					};
				}
				if (tab.name === "language") {
					return {
						...tab,
						props: {
							...tab.props,
							value: this.languagePropsData,
						},
					};
				}
				if (tab.name === "personal") {
					return {
						...tab,
						props: {
							...tab.props,
							value: this.personalPropsData,
						},
					};
				}
				if (tab.name === "marketing") {
					return {
						...tab,
						props: {
							...tab.props,
							value: this.marketingPropsData,
						},
					};
				}
				if (tab.name === "placement") {
					return {
						...tab,
						props: {
							...tab.props,
							value: this.placementPropsData,
						},
					};
				}
				if (tab.name === "schedule") {
					return {
						...tab,
						props: {
							...tab.props,
							value: this.schedulePropsData,
						},
					};
				}
				if (tab.name === "finance") {
					return {
						...tab,
						props: {
							...tab.props,
							value: this.financePropsData,
						},
					};
				}
				if (tab.name === 'class') {
					return {
						... tab,
						props: {
							... tab.props,
							value: this.classPropsData
						}
					}
				}
				if (tab.name === 'packages') {
					return {
						... tab,
						props: {
							... tab.props,
							value: this.packagesPropsData
						}
					}
				}
				if (tab.name === 'invoice') {
					return {
						... tab,
						props: {
							... tab.props,
							value: this.invoicePropsData
						}
					}
				}
				if (tab.name === 'VA Number') {
					return {
						... tab,
						props: {
							... tab.props,
							value: this.vanumberPropsData
						}
					}
				}
				return tab;
			});
		},
	},
	methods: {
		async fetchData() {
			try {
				const userResponse = await axios.get(
					"/transaction/lead/" + this.id
				);

				// assign data to logPropsData
				this.logPropsData = userResponse.data;

				// assign data to basicInfoPropsData
				this.basicInfoPropsData = userResponse.data;

				// assign data to languagePropsData
				this.languagePropsData = userResponse.data;

				// assign data to personalPropsData
				this.personalPropsData = userResponse.data;

				// assign data to marketingPropsData
				this.marketingPropsData = userResponse.data;

				// assign data to placementPropsData
				this.placementPropsData = userResponse.data;

				// assign data to schedulePropsData
				this.schedulePropsData = userResponse.data;

				// assign data to financePropsData
				this.financePropsData = userResponse.data;

				// assign data to classPropsData
				this.classPropsData = userResponse.data;
				this.packagesPropsData = userResponse.data;
				this.invoicePropsData = userResponse.data;
				this.vanumberPropsData = userResponse.data;
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		},
	},
};
</script>

<style scoped>
.content-wrapper {
	margin-bottom: 200px; /* Adjust the margin value as needed */
}
.card {
	box-shadow: 0 10px 12px rgba(0, 0, 0, 0.2); /* You can adjust the values to control the shadow effect */
}
</style>
